import type { Campus, UrlEntry, UrlRegion } from '@/types';

export type CampusPages = `campus/${Campus}`;

export const urls: Record<CampusPages, Partial<Record<UrlRegion, UrlEntry>>> = {
  'campus/ams': {
    nl: 'amsterdam',
    'nl-en': 'amsterdam',
  },
  'campus/bcn': {
    es: 'barcelona',
    'es-en': 'barcelona',
  },
  'campus/ber': {
    de: 'berlin',
    'de-en': 'berlin',
  },
  'campus/lis': {
    pt: 'lisboa',
    'pt-en': 'lisbon',
  },
  'campus/lon': {
    gb: 'london',
  },
  'campus/mad': {
    es: 'madrid',
    'es-en': 'madrid',
  },
  'campus/par': {
    fr: 'paris',
    'fr-en': 'paris',
  },
  'campus/rmt': {
    de: 'remote',
    'de-en': 'remote',
    es: 'remoto',
    'es-en': 'remote',
    fr: 'a-distance',
    'fr-en': 'remote',
    gb: 'remote',
    nl: 'remote',
    'nl-en': 'remote',
    pt: 'remoto',
    'pt-en': 'remote',
    us: 'remote',
    ww: 'remote',
  },
};
